module.exports = __webpack_public_path__ + "img/home-miniapp.da13533.webp";